import { manufacturesIcon } from "assets/icons/svgIcons";

export default [
  {
    id: "manufacturers",
    title: "Manufacturers",
    icon: manufacturesIcon,
    pageTitle: "Manufacturers List",
    navLink: "/manufacturers",
    type: "item",
    permissions: ["super_admin"],
  },
];
